import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useFormContext } from 'react-hook-form';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useFullscreenModalControls } from '../../modals/context/modal-context-provider';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { EventPanelFormType } from '@mark43/cad-api';
import { useRefreshEventPanel } from '../refresh-event-panel';

export function ScheduledEventKebabMenu(): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const workspacePanel = useWorkspacePanel();
    const eventForm = useFormContext<EventPanelFormType>();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const refreshEventPanel = useRefreshEventPanel();
    return (
        <Menu>
            <MenuTrigger asChild>
                <IconButton
                    data-testid="other-options-menu"
                    variant="ghost"
                    icon="MoreActions"
                    aria-label="more actions"
                />
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    onSelect={() => {
                        eventForm.trigger().then((passedValidation) => {
                            if (passedValidation && eventPanelOptions) {
                                modalControls.open({
                                    type: 'SCHEDULE_EVENT',
                                    props: {
                                        form: eventForm,
                                        eventPanelOptions,
                                        refreshEventPanel,
                                        workspacePanel,
                                    },
                                });
                            }
                        });
                    }}
                >
                    Edit Scheduled Date/Time
                </MenuItem>
            </MenuContent>
        </Menu>
    );
}
